export const REPORT_TITLES: Record<number, string> = {
  1: "Served On Team",
  2: "Never Served On Team",
  3: "Given A Talk",
  4: "Never Given A Talk",
  6: "Participated In Last 2 Years",
  8: "Served As A Retreat Lead Couple",
  9: "Served As A Head Of Service",
  10: "Never Served As A Head Of Service",
};

export function reportTitle(reportId: number | string | null | undefined): string {
  const id = Number(reportId);
  return REPORT_TITLES[id] || "";
}
